/**
 * @license
 * Copyright 2026 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
// Generated stylesheet for ./chips/internal/chip-set-styles.css.
import {css} from 'lit';
export const styles = css`:host{display:flex;flex-wrap:wrap;gap:8px}
`;
export default styles.styleSheet!;
